import axios from 'axios';
import { useEffect, useState } from 'react';
import { Button, Chip, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { useSnackbar } from 'notistack';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import { ProjectConfig } from 'Global';
import moment from 'moment';
import AddIcon from '@mui/icons-material/Add';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import 'assets/css/main.css';
import UsersEditor from './UsersEditor';
import ExportDialog from '../../Utils/ExportDialog';
import EmptyElement from 'elements/EmptyElement';
import TuneIcon from '@mui/icons-material/Tune';
import ListPagination from 'elements/ListPagination';
import FiltersByTable from 'elements/Filters/FiltersByTable';
import FiltersApplied from 'elements/Filters/FiltersApplied';

export default function OrdersList(props: any) {
  const [open, setOpen] = useState(false);
  const [filtersValues, setFiltersValues] = useState<any>([]);
  const { company_id = null, is_popup = false } = props;
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const { setLoading } = props;

  // Añadir el estado filtersList
  const [filtersList, setFiltersList] = useState<any[]>([]);
  const [exportFields, setExportFields] = useState<string[]>([]);
  const [openExportDialog, setOpenExportDialog] = useState(false);

  useEffect(() => {
    setLoading(false);
  }, []);

  const [list, setList] = useState<any[]>([]);
  const [pagination, setPagination] = useState({ total_pages: 1, total_items: 0 });
  const queryParams = new URLSearchParams(window.location.search);
  const currentPage = 1;
  const [page, setPage] = useState(currentPage);
  const [refreshList, setRefreshList] = useState(0);
  const [openEditor, setOpenEditor] = useState(false);

  useEffect(() => {
    loadList();
  }, [page, filtersValues]);

  useEffect(() => {
    if (page !== 1) {
      setPage(1);
    }
  }, [filtersValues]);

  const loadList = (download = false, userExportFields: any = null) => {
    setLoading(true);
    const params: any = {
      page: page,
      filters: filtersValues,
      download,
    };
    
    // Solo agregar userExportFields si hay campos seleccionados
    if (userExportFields && userExportFields.length > 0) {
      params.userExportFields = userExportFields;
    }
    
    axios
      .get(ProjectConfig.api_url + "/orders/list", {
        headers: { ltkn: localStorage.getItem("ltkn") },
        params: params,
      })
      .then((response) => {


          console.log("LIST RESPONSE", response.data);
        if (download) {
          const url = response.data.csv; // Suponiendo que response.data.csv es la URL directa al archivo CSV.
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "orders.csv");
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link); // Elimina el enlace después de descargar.
        }else{
          setList(response.data.list);
          setPagination(response.data.pagination);
          setFiltersList(response.data.filtersList);
          setExportFields(response.data.exportFields || []);
        }

        setLoading(false);
      })
      .catch((err) => {
        console.log(err.response.data);
      })
      .finally(() => {
        setLoading(false);
      });
    localStorage.setItem("page", page.toString());
  };

  const handleDelete = (user_id: number) => {
    setActiveItem(user_id);
    setOpenAlert(true);
  };

  const [openAlert, setOpenAlert] = useState(false);
  const [activeItem, setActiveItem] = useState<any>(null);

  const handleExportCSV = (selectedFields: string[] | null) => {
    loadList(true, selectedFields);
  };



  return (
    <div id='UsersList' className='ModuleContainer'>
      <div className="ModuleWrapper"> 
        <div className="boxContainerHeader">
          <div className="boxContainerTitle">
            <h1>Orders</h1>
          </div>

          <div className="componentTools">
            <FiltersByTable
              filters={filtersList}
              setFilters={setFiltersValues}
              searchBy={["c.email", "c.name", "c.lastname", "a.address", "a.city","a.zip_code","countries.country_name", "co.company_name", "op.product_name", "o.created_at"]} 
            />
            
            <div>
              <Button 
                variant="contained"
                className="button_3"
                size="small"
                onClick={() => setOpenExportDialog(true)}
              >
                Export CSV
              </Button>
            </div>
          </div>
          <FiltersApplied filters={filtersValues} setFilters={setFiltersValues} />
        </div>
        <div id='UsersListIn'>
          <div>
            {list.length !== 0 ? (
              <TableContainer>
                <Table aria-label="sticky table"> 
                  <TableHead>
                    <TableRow>
                      <TableCell sx={{ color: '#a8a8a8', borderBottom: "none" }}>Date</TableCell>
                      <TableCell sx={{ color: '#a8a8a8', borderBottom: "none" }}>Email</TableCell>
                      <TableCell sx={{ color: '#a8a8a8', borderBottom: "none" }}>First Name</TableCell>
                      <TableCell sx={{ color: '#a8a8a8', borderBottom: "none" }}>Last Name</TableCell>
                      <TableCell sx={{ color: '#a8a8a8', borderBottom: "none" }}>Address</TableCell>
                      <TableCell sx={{ color: '#a8a8a8', borderBottom: "none" }}>City</TableCell>
                      <TableCell sx={{ color: '#a8a8a8', borderBottom: "none" }}>Zip Code</TableCell>
                      <TableCell sx={{ color: '#a8a8a8', borderBottom: "none" }}>Country</TableCell>
                      <TableCell sx={{ color: '#a8a8a8', borderBottom: "none" }}>Company</TableCell>
                      <TableCell sx={{ color: '#a8a8a8', borderBottom: "none" }}>Order</TableCell>
                      <TableCell sx={{ color: '#a8a8a8', borderBottom: "none" }}>Domain Status</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {list.map((item, i) => (
                      <TableRow key={i} hover role="checkbox"
                        sx={{
                          '&:hover': {
                            backgroundColor: '#ecebff !important', // Color del hover
                          },
                        }}
                      >
                        <TableCell>{item.date}</TableCell>
                        <TableCell>{item.email}</TableCell>
                        <TableCell>{item.name}</TableCell>
                        <TableCell>{item.lastname}</TableCell>
                        <TableCell>{item.address}</TableCell>
                        <TableCell>{item.city}</TableCell>
                        <TableCell>{item.zip_code}</TableCell>
                        <TableCell>{item.country_name}</TableCell>
                        <TableCell>{item.company_name}</TableCell>
                        <TableCell>{item.products}</TableCell>
                        <TableCell>
                          {item.is_production_domain ? (
                            <Chip label="Production" style={{ backgroundColor: "#D9F9BA", color: "#417029", borderRadius: "5px" }} />
                          ) : (
                            <Chip label="Staging" style={{ backgroundColor: "#f5f5f5", color: "#666666", borderRadius: "5px" }} />
                          )}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            ) : (
              <div className="emptyList">
                <EmptyElement title="No orders" />
              </div>
            )}
            {pagination.total_pages > 1 && (
              <ListPagination 
                pagination={pagination} 
                page={page}  
                onChange={(event: any, value: any) => setPage(value)} 
                label="Orders"
                style={{ marginTop: "20px", alignSelf: "center" }}
              />
            )}
          </div>
        </div>
      </div>
      <UsersEditor
        setLoading={setLoading}
        openEditor={openEditor} 
        setOpenEditor={setOpenEditor}
        user_id={activeItem} 
        loadList={loadList}
        company_id={company_id}
      />
      
      <ExportDialog
        open={openExportDialog}
        setOpen={setOpenExportDialog}
        setLoading={setLoading}
        exportFields={exportFields}
        onExport={handleExportCSV}
      />
    </div>
  );
};
